import { render, staticRenderFns } from "./secondHandOrder.vue?vue&type=template&id=5687f29c&"
import script from "./secondHandOrder.vue?vue&type=script&lang=ts&"
export * from "./secondHandOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "secondHandOrder.vue"
export default component.exports